import { iconSizes, r, s } from '@/theme/tokens';
import { Stack } from '@/ui/layout/Stack';
import { Box, Text } from '@/ui/primitives';
import { TestingUploadResultsAction } from './TestingUploadResultsAction';
import type { SvgIconComponent } from '@/ui/primitives';
import type { ReactElement } from 'react';

type TestingListEmptyStateProps = {
  body: string;
  icon: SvgIconComponent;
  title: string;
  uploadDisabled?: boolean;
  uploadDisabledReason?: string | null;
  onUploadClick: () => void;
};

export const TestingListEmptyState = ({
  body,
  icon: EmptyStateIcon,
  title,
  uploadDisabled = false,
  uploadDisabledReason,
  onUploadClick,
}: TestingListEmptyStateProps): ReactElement => (
  <Box
    data-testid="testing-list-empty-state"
    sx={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: { xs: '28rem', md: '34rem' },
      px: s('md'),
      py: s('5xl'),
    }}
  >
    <Stack align="center" gap="md" sx={{ maxWidth: '30rem', textAlign: 'center', width: '100%' }}>
      <Box
        aria-hidden="true"
        sx={{
          alignItems: 'center',
          borderRadius: r('pill'),
          color: 'text.secondary',
          display: 'flex',
          height: '2.5rem',
          justifyContent: 'center',
          width: '3.75rem',
        }}
      >
        <EmptyStateIcon sx={{ fontSize: iconSizes.xxl }} />
      </Box>
      <Stack align="center" gap="md">
        <Text role="pageTitle" component="h2">
          {title}
        </Text>
        <Text
          role="bodyMuted"
          color="textSecondary"
          sx={(theme) => ({ fontSize: theme.typography.h5.fontSize, maxWidth: '25rem' })}
        >
          {body}
        </Text>
      </Stack>
      <Box sx={{ pt: s('sm') }}>
        <TestingUploadResultsAction
          disabledReason={uploadDisabled ? (uploadDisabledReason ?? '') : null}
          onClick={onUploadClick}
        />
      </Box>
    </Stack>
  </Box>
);
